import redirectionLink from "./Redirection";
import environment from './Environment';
import authToken from './Authorization';

const configUrlObj = {
    redirectionLink,
    environment,
    authToken
}

export default configUrlObj;
